module.exports = __webpack_public_path__ + "assets/img/rzsb.0860fcbf.png";